/* Embroidery Inc homepage 2026-10: "How it works" steps (sections/ei-steps.liquid).
   1. Sews the running-stitch line from step to step once, as the numbers scroll into view
      (each number lights up when the thread reaches it, 420ms apart).
   2. Smooth-scrolls in-page links marked data-ei-scroll (e.g. "Shop by category").
   The finished state is the default in CSS, so without this file everything is drawn and lit. */
(function () {
  'use strict';

  var STEP_MS = 420;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reducedMotion() {
    return !!(mq && mq.matches) || !!(navigator.connection && navigator.connection.saveData);
  }

  /* Sections marked data-ei-cv use content-visibility: auto, so one that has not been shown yet only
     holds an estimated height. Render the ones above the target first so the scroll lands exactly. */
  function settle(target) {
    var cv = document.querySelectorAll('[data-ei-cv]');
    for (var i = 0; i < cv.length; i++) {
      if (cv[i].compareDocumentPosition(target) & 4) cv[i].style.contentVisibility = 'visible';
    }
  }

  /* Height of the sticky header (the theme makes the header-group wrapper position: sticky). */
  function stickyOffset() {
    var el = document.querySelector('store-header[data-is-sticky]');
    while (el && el !== document.body) {
      var pos = window.getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') {
        var r = el.getBoundingClientRect();
        return r.bottom > 0 ? r.height : 0;
      }
      el = el.parentElement;
    }
    return 0;
  }

  function onScrollLink(e) {
    var href = this.getAttribute('href') || '';
    var hash = href.slice(href.indexOf('#'));
    if (hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    settle(target);
    var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: reducedMotion() ? 'auto' : 'smooth' });
    if (window.history && history.pushState) history.pushState(null, '', hash);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (err) { /* old browsers */ }
  }

  function init(root) {
    if (!root || root.getAttribute('data-ei-steps-ready') === '1') return;
    root.setAttribute('data-ei-steps-ready', '1');

    var links = root.querySelectorAll('a[data-ei-scroll]');
    for (var i = 0; i < links.length; i++) links[i].addEventListener('click', onScrollLink);

    var steps = Array.prototype.slice.call(root.querySelectorAll('.ei-step'));
    var armed = root.hasAttribute('data-animate') &&
      document.documentElement.classList.contains('ei-js') &&
      'IntersectionObserver' in window && !reducedMotion() && steps.length > 0;
    if (!armed) { root.classList.add('is-done'); return; }

    var target = -1;   // furthest step whose number has been seen
    var current = -1;  // furthest step lit so far
    var busy = false;
    var io;

    function finish() {
      root.classList.add('is-done');
      if (io) io.disconnect();
    }

    function next() {
      if (current >= target) { busy = false; if (current === steps.length - 1) finish(); return; }
      busy = true;
      var n = current + 1;
      if (n === 0) {
        steps[0].classList.add('is-lit');
        current = 0;
        next();
        return;
      }
      steps[n - 1].classList.add('is-sewn'); /* thread runs from the previous number to this one */
      window.setTimeout(function () {
        steps[n].classList.add('is-lit');
        current = n;
        next();
      }, STEP_MS);
    }

    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = steps.indexOf(entry.target.closest('.ei-step'));
        io.unobserve(entry.target);
        if (idx > target) target = idx;
      });
      if (!busy) next();
    }, { rootMargin: '0px 0px -12% 0px', threshold: 1 });

    steps.forEach(function (step) {
      var num = step.querySelector('.ei-step__num');
      if (num) io.observe(num);
    });

    /* If motion gets switched off mid-way, jump to the finished state. */
    if (mq && mq.addEventListener) mq.addEventListener('change', function () { if (mq.matches) finish(); });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ei-steps]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-ei-steps]');
    if (root) init(root);
  });
})();
